import React, { useEffect, useState } from "react";
import FormikControl from "../../../../components/FormikControls/FormikControl";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { Formik, Form } from "formik";
import { useSelector } from "react-redux";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import { ErrorMessage } from "formik";
import "../../../CompanyManagment/Forms/RegisterTenant/Error.css";
import MultiSelect from "../../../../components/FormikControls/MultiSelect/MultiSelect";
import DyLoadingCircular from "../../../../components/GlobalComponents/DyLoadingCircular/DyLoadingCircular";
import { useAddDeterminingSituationAlignmentMeeting } from "../../../CompanyTeams/Hooks";

const ApplicantFinalOpinion = ({
  //onSuccess,
  setShowToastMessage,
  setObjectiveAsyncOpState,
  afterSuccess,
  onClose,
  teamId,
  periodId,
  keyResultId,
  meetingId,
  cooperateId
}: any) => {
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
//  const [teamName, setTeamName] = useState<any>({
//     teamName: null,
//   });
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
//   const [teamId, setTeamId] = useState<any>();
  // const [addObjError, setAddObjError] = useState<any>(null);
  // const [selectedRowData, setSelectedRowData] = React.useState<any>([]);
  // const [allTeamsData, setAllTeamsData] = useState<any>(null);
  
  const requestPriorityData = [
    { key: "توافق و اعمال", value: "Accept" },
    { key: "پس گرفتن درخواست", value: "TakeBack" },
    { key: "عدم توافق", value: "Disagreement" },
  ];

  const {
    mutate: addObjective,
    data: addObjectiveData,
    // isSuccess,
    // isLoading,
    // isError: isErrorInAddObjective,
  } = useAddDeterminingSituationAlignmentMeeting();

  useEffect(() => {
    if (addObjectiveData) {
      if (addObjectiveData?.data.isSuccess) {
        // setSuccessAddObjective(isSuccess)
        setShowToastMessage(true);
        SetIsSuccess(true);
        SetTMessage(addObjectiveData?.data.metaData.message);
        //onSuccess();
        onClose(false);
      } else {
        setShowLtoastMessage(true);
        SetIsSuccess(false);
        SetTMessage(addObjectiveData?.data.metaData.message);
        //setAddObjError(addObjectiveData?.data);
      }
    }
  }, [addObjectiveData]);

  const initialAddObjective = async (data: any) => {
    data.alignmentType = 'Request';
    data.teamId = teamId;
    data.meetingId = meetingId;
    data.periodId = periodId;
    data.keyResultId = keyResultId;
    data.cooperateId = cooperateId;
    data.tenantId = tenantId;
    data.DeterminingSituationType = 'FromRequest';
   await addObjective({...data,tenantId:tenantId});
  };


  return (
    <>
      <Box width={"100%"} maxHeight={"50em"}>
        <Formik
          enableReinitialize
          validate={(data) => {
          }}
          initialValues={{ }}
          onSubmit={(data) => {
            initialAddObjective(data);
          }}
        >
          {({
            values,
            setFieldValue,
            dirty,
            isValid,
            touched,
            errors,
            setFieldTouched,
            handleChange,
          }: any) => (
            <Form>
              <Grid container>

                    <Grid item xs={12} md={12}>
                      <FormikControl
                        control="select"
                        type="select"
                         label="نظر نهایی"
                        options={requestPriorityData}
                        name="determiningType"
                        fullWidth
                      />
                    </Grid>

                       <Grid item xs={12} md={12}>
                            <FormikControl
                                control="textField"
                                type="text"
                                label="توضیحات"
                                name="description"
                                fullWidth
                                value={values?.description || ''}
                                placeholder="توضیحات"
                                multiline
                                minRows={5} // تعداد ردیف‌های اولیه که ارتفاع را افزایش می‌دهد
                            />
                        </Grid>


                <Grid item xs={12} md={12} mt={3}>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"end"}
                    flexDirection={"row-reverse"}
                    columnGap={2}
                  >
                      <Box width={"20%"}>
                            <DyButton
                              disabled={false}
                              variant={"contained"}
                              bgColor={"info"}
                              caption={'ثبت'}
                              type={"submit"}
                              onClick={() => { }}
                            />
                          </Box>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
      </Box>
    </>
  );
};

export default ApplicantFinalOpinion;


//نظر نهایی درخواست کننده 